import { render } from "./FileUploadButton.vue?vue&type=template&id=1a176ec8&scoped=true"
import script from "./FileUploadButton.vue?vue&type=script&lang=ts"
export * from "./FileUploadButton.vue?vue&type=script&lang=ts"

import "./FileUploadButton.vue?vue&type=style&index=0&id=1a176ec8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a176ec8"

export default script